<template>
  <div class="section">
    <h6>{{ $t('Tool.TableColor') }}</h6>
    <color-setting ref="color" />
    <template v-if="$checkPermission(['button_allowCustomPage'])">
      <h6>{{ $t('Message.CustomPageSettings') }}</h6>
      <div style="padding: 20px;text-align: center;">
        <el-button type="primary" style="background-color: #409EFF;border-color: #409EFF;" @click="enterCustomPageSetting">
          {{ $t('Message.EnterCustomPageSettings') }}
        </el-button>
      </div>
    </template>
    <h6>{{ $t('Tool.PartnerDisplayControl') }}</h6>
    <partner-label-setting ref="partner" />
    <h6 />
    <job-copy-setting ref="jobCopySetting" />
    <h6 />
    <div v-if="showImperials">
      <imperial-setting ref="imperial" />
    </div>
  </div>
</template>

<script>
import ColorSetting from '@/components/Cargo/Common/NavbarMenu/components/SettingAndTools/ColorSetting'
import PartnerLabelSetting from '@/components/Cargo/Common/NavbarMenu/components/SettingAndTools/PartnerLabelSetting'
import JobCopySetting from '@/components/Cargo/Common/NavbarMenu/components/SettingAndTools/JobCopySetting'
import ImperialSetting from '@/components/Cargo/Common/NavbarMenu/components/SettingAndTools/imperialSetting.vue'
import { getSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
export default {
  name: 'PagePersonalization',
  components: { ImperialSetting, PartnerLabelSetting, ColorSetting, JobCopySetting },
  data() {
    return {
      showImperials: false
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      const imperials = await getSpecificBasicData(basicCacheKeys.basic_data_ImperialUnitsSetting)
      if (imperials && imperials.length > 0) {
        this.showImperials = Boolean(imperials[0].openAe)
      } else {
        this.showImperials = false
      }
    },
    // 废弃
    reload() {
      console.log('PagePersonalization-reload')
      this.$refs.color.reload()
      this.$refs.partner.reload()
      this.$refs.resetJobCopy.reload()
    },
    enterCustomPageSetting() {
      this.$router.push({ name: 'CustomPage' })
    }
  }
}
</script>

<style lang="scss" scoped>
.section{
  max-width: 500px;
  margin: 0 auto;
  border: 2px solid #E3E7ED;
  border-radius: 8px;
  h6{
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    border-bottom: 2px solid #E3E7ED;
    margin: 0;
    box-sizing: border-box;
    color: #313131;
    font-size: 13px;
    font-weight: normal;
  }
}
</style>
